module.exports = __webpack_public_path__ + "assets/img/font3.aa64c91e.png";